import "./MeetingEmptyState.scss";

import { Flex } from "@fluentui/react-northstar";
import React from "react";

import MeetingStateImage from "../../../../_shared/assets/meeting.svg";

type Props = {
  header: React.ReactNode;
  subtext?: React.ReactNode;
  size?: number;
};

export const MeetingEmptyState: React.FC<Props> = ({ header, subtext, size = 150 }) => {
  return (
    <Flex column gap="gap.large" hAlign="center" className="meeting-empty-state">
      {header}

      <img src={MeetingStateImage} height={size} alt="Meeting Empty" />

      {subtext}
    </Flex>
  );
};
